import { useRestart } from '@hooks/utils/useRestart';
import { isMeetingError } from '@stores/atoms/device';
import { useResetAtom } from 'jotai/utils';
import type { FC, MouseEventHandler } from 'react';
import Modal from '../Interview';

const MeetingErrorModal: FC = () => {
  const { executeRestart } = useRestart();
  const resetMeetingError = useResetAtom(isMeetingError);

  const onClickConfirm: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation();
    resetMeetingError();
    await executeRestart();
  };

  return (
    <Modal onClickConfirm={onClickConfirm} isUnrejectable={true}>
      요청하신 페이지를 처리할 수 없습니다.
      <br />
      서비스 이용에 불편을 드려 죄송합니다.
      <br />
      서비스 이용 중 동일한 현상이 반복될 경우, 관리자 또는 고객센터에 문의해
      주시기 바랍니다.
    </Modal>
  );
};

export default MeetingErrorModal;
